import { memo, useMemo } from "react";
import styled from "styled-components";

import type { Character } from "@core/types/character";

import GoldIcon from "@assets/images/ico_gold.png";

interface Props {
  character: Character;
}

const fmt = (n: number) =>
  n.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

/**
 * 합계 셀 (sticky right).
 * - 현재 획득 주간 골드 / 예상 총 주간 골드 (레이드 기준)
 * - 캐릭터 귀속 골드가 있으면 보조 라인으로 표시
 */
const TotalGoldCell = ({ character }: Props) => {
  const { current, expected, charCurrent, charExpected } = useMemo(() => {
    const exp = character.todoList.reduce((acc, t) => acc + t.realGold, 0);
    const charExp = character.todoList.reduce(
      (acc, t) => acc + t.characterGold,
      0
    );
    return {
      current: character.weekRaidGold,
      expected: exp,
      charCurrent: character.weekCharacterRaidGold,
      charExpected: charExp,
    };
  }, [
    character.todoList,
    character.weekRaidGold,
    character.weekCharacterRaidGold,
  ]);

  const isDone =
    expected > 0 &&
    current === expected &&
    charCurrent === charExpected;

  return (
    <Wrapper $isDone={isDone}>
      <Main>
        {fmt(current)} / {fmt(expected)} G
      </Main>
      {charExpected !== 0 && (
        <Sub>
          귀속 {fmt(charCurrent)} / {fmt(charExpected)}
        </Sub>
      )}
    </Wrapper>
  );
};

export default memo(TotalGoldCell);

const Wrapper = styled.div<{ $isDone: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 10px 6px 24px;
  background: url(${GoldIcon}) no-repeat 8px 8px;
  background-size: 13px 13px;
  min-height: 44px;
  opacity: ${({ $isDone }) => ($isDone ? 0.4 : 1)};
  text-decoration: ${({ $isDone }) => ($isDone ? "line-through" : "none")};
`;

const Main = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.app.text.dark2};
  line-height: 1.2;
  white-space: nowrap;
`;

const Sub = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.app.text.light2};
  line-height: 1.2;
  white-space: nowrap;
`;
